import React from 'react';
import classNames from 'classnames';
import { IconCheckCircle } from '@pentabd/icons';

import Text from '../../atoms/text/Text';
import { Button } from '../../atoms/button';
import useMediaQuery, { SCREEN_SIZES } from '../../hooks/useMediaQuery';

export interface CTAItemProps {
  title?: string;
  subtitle?: string;
}

export interface CTAProps {
  title?: string;
  subtitle?: string;
  type?: 'avatar-card' | 'item-list-card' | 'file-card';
  avatar?: string;
  buttonFillLabel?: string;
  onClickFill?: () => void;
  buttonOutLineLabel?: string;
  onClickOutLine?: () => void;
  fileImg?: string;
  fileName?: string;
  fileSize?: string;
  items?: CTAItemProps[];
}

const CTA = ({
  title,
  subtitle,
  type,
  avatar,
  buttonFillLabel,
  onClickFill,
  buttonOutLineLabel,
  onClickOutLine,
  fileImg,
  fileName,
  fileSize,
  items,
}: CTAProps) => {
  const isMobile = useMediaQuery(`(max-width: ${SCREEN_SIZES.MD})`);

  const ActionView = () => (
    <div
      className={classNames('d-flex gap-6 w-100', {
        'flex-column': isMobile,
        'justify-content-end': !isMobile && type === 'file-card',
      })}
    >
      <Button
        fill="outline"
        size="md"
        type="dark"
        onClick={onClickOutLine}
        className={classNames({
          'order-1': !isMobile,
          'order-2': isMobile,
        })}
      >
        <Text size="sm" weight="semibold">
          {buttonOutLineLabel}
        </Text>
      </Button>
      <Button
        fill="fill"
        type="primary"
        size="md"
        onClick={onClickFill}
        className={classNames({
          'order-2': !isMobile,
          'order-1': isMobile,
        })}
      >
        <Text size="sm" weight="semibold">
          {buttonFillLabel}
        </Text>
      </Button>
    </div>
  );
  return (
    <div
      className={classNames(
        'd-flex justify-content-start',
        'bg-white',
        'border border-light',
        'rounded-4',
        'shadow-xs',
        'w-100',
        { 'flex-column': isMobile },
      )}
    >
      {avatar && (
        <div className={classNames('rounded-4', { 'w-25': !isMobile })}>
          <img
            src={avatar}
            alt="avatar"
            className={classNames('img-fluid  d-block', {
              'rounded-start-3': !isMobile,
              'rounded-top-3': isMobile,
            })}
          />
        </div>
      )}

      <div
        className={classNames(
          'd-flex flex-column justify-content-between gap-8 p-12',
          { 'w-100': !avatar },
        )}
      >
        <div>
          <Text component="h2" size="lg" weight="semibold" color="dark">
            {title}
          </Text>
          <Text size="sm" weight="normal" color="subtitle1">
            {subtitle}
          </Text>
        </div>

        {/* card body  */}

        {type === 'item-list-card' && (
          <>
            {items.map((item, index) => (
              <div
                key={index}
                className="d-flex justify-content-start align-items-start"
              >
                <IconCheckCircle height="24" width="24" fill="dark" />
                <div className="ms-3">
                  <Text component="h4" color="title" weight="medium">
                    {item.title}
                  </Text>
                  <Text component="p" color="subtitle2">
                    {item.subtitle}
                  </Text>
                </div>
              </div>
            ))}
          </>
        )}

        {/* card footer  */}

        {(type === 'avatar-card' || type === 'item-list-card') && (
          <ActionView />
        )}

        {type === 'file-card' && (
          <div
            className={classNames(
              'd-flex justify-content-between border border-light rounded-4 p-8 w-100',
              { 'flex-column gap-10': isMobile },
              { 'align-items-center': !isMobile },
            )}
          >
            <div className="d-flex justify-content-start align-items-center">
              <div className="me-6 cta-file-upload-img-width">
                <img src={fileImg} className="img-fluid" alt="" />
              </div>
              <div className="ms-3">
                <Text component="p" size="lg" color="title" weight="medium">
                  {fileName}
                </Text>
                <Text size="sm" color="subtitle2">
                  {fileSize}
                </Text>
              </div>
            </div>
            <ActionView />
          </div>
        )}
      </div>
    </div>
  );
};

export default CTA;
